import { render, staticRenderFns } from "./select-question.vue?vue&type=template&id=188c9a59&scoped=true&"
import script from "./select-question.vue?vue&type=script&lang=js&"
export * from "./select-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c9a59",
  null
  
)

export default component.exports